<div>
    <v-dialog persistent max-width="48em" v-model="isOpen">
        <template v-slot:activator="{ props }">
            <v-btn class="" color="primary" :elevation="0" v-bind="props">Nachricht senden</v-btn>
        </template>
        <contact-form :token="token" @success="success" @cancel="cancel" />
    </v-dialog>
</div>
